export class MechGradeAuth {
    mechGrade: string;
    notes: string;

    constructor(mechGrade: string, notes: string) {
        this.mechGrade = mechGrade;
        this.notes = notes;
    }
}
